import { storageKeys } from '../enums/storageKeys'

export default {
  set: (key, data) => {
    if (typeof data === 'string') {
      localStorage.setItem(key, data)
    } else {
      localStorage.setItem(key, JSON.stringify(data))
    }
  },

  get: (key) => {
    const rawData = localStorage.getItem(key)
    let data = ''

    try {
      data = JSON.parse(rawData)
    } catch (_) {
      data = rawData
    }

    return data
  },

  remove: (key) => {
    localStorage.removeItem(key)
  },

  clear: () => {
    // Preserve unleash data during logout since feature flags should persist across sessions
    const { UNLEASH, UNLEASH_SESSION_ID } = storageKeys
    const unleashRepo = localStorage.getItem(UNLEASH)
    const unleashSessionId = localStorage.getItem(UNLEASH_SESSION_ID)

    localStorage.clear()

    if (unleashRepo) {
      localStorage.setItem(UNLEASH, unleashRepo)
    }
    if (unleashSessionId) {
      localStorage.setItem(UNLEASH_SESSION_ID, unleashSessionId)
    }
  },
}
